export const SYMBOL_FONT_SIZE = 10;
export const SYMBOL_FONT_WEIGHT = 600;

export const SYMBOL_ICON_SIZE = 14;
export const SYMBOL_ICON_MARGIN = 4;

export const SYMBOL_HORIZONTAL_MARGIN = 12;
